import { UUID } from '@/types/types';
import { pick } from 'lodash';
import { RootState, AppDispatch } from '.';
import {
	changeSelectedAttributes,
	changeSelectedComponent,
	insertMessage,
	updateProduct,
} from './slices/creatorSlice';
import { createListenerMiddleware } from '@reduxjs/toolkit';
import ProductApi, { Product } from '@/api/ProductApi';
import ComponentApi from '@/api/ComponentApi';

export const creatorListenerMiddleware = createListenerMiddleware();

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: changeSelectedComponent,
	effect: async ({ payload }, listenerApi) => {
		const { options, product } = listenerApi.getState().creator;

		if (!options.isInitialized) return;

		let updatedProduct: Product | undefined;

		let componentCategoryId: UUID;
		for (componentCategoryId in options.selectedComponents) {
			const selectedComponent = options.selectedComponents[componentCategoryId];

			const productComponent = product.productComponents.find(
				({ componentData }) =>
					componentData.componentCategory.id === componentCategoryId
			);

			if (!selectedComponent && !productComponent) continue;
			if (!selectedComponent) {
				updatedProduct = await ProductApi.updateProductComponent({
					productId: product.id,
					oldProductComponentId: productComponent?.id,
				});
				continue;
			}

			if (productComponent?.componentData.id === selectedComponent.id) continue;

			updatedProduct = await ProductApi.updateProductComponent({
				productId: product.id,
				componentId: selectedComponent.id,
				oldProductComponentId: productComponent?.id,
			});
		}

		if (updatedProduct)
			listenerApi.dispatch(
				updateProduct(
					pick(updatedProduct, [
						'updatedAt',
						'productComponents',
						'netPrice',
						'grossPrice',
					])
				)
			);
	},
});

creatorListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: insertMessage,
	effect: async ({ payload }, listenerApi) => {
		if (!payload.referencedComponents) return;

		for (const reference of payload.referencedComponents) {
			ComponentApi.mutationGetOne(reference.componentId).then((component) => {
				for (const attributeValue of component.attributeValues) {
					listenerApi.dispatch(
						changeSelectedAttributes({
							componentCategoryId: reference.componentCategoryId,
							attributeId: attributeValue.attribute.id,
							attributeValueId: attributeValue.id,
						})
					);
				}
			});
		}
	},
});
